module.exports = __webpack_public_path__ + "images/icon-done-dc63bceca472a1870de48164942565e4.png";